import { render, staticRenderFns } from "./productionStationDialog.vue?vue&type=template&id=54141250&"
import script from "./productionStationDialog.vue?vue&type=script&lang=js&"
export * from "./productionStationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports